import { render, staticRenderFns } from "./manual-order-record.vue?vue&type=template&id=580e7524&"
import script from "./manual-order-record.vue?vue&type=script&lang=js&"
export * from "./manual-order-record.vue?vue&type=script&lang=js&"
import style0 from "./manual-order-record.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports